import { useEffect, useRef } from 'react';

const IdleTimer = ({ onTimeout, timeout = 20 * 60 * 1000 }) => {
  const UserId = localStorage.getItem("accountId");



  const timerRef = useRef(null);

  const resetTimer = () => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(onTimeout, timeout);
  };

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'scroll', 'click', 'touchstart'];

    events.forEach(event => window.addEventListener(event, resetTimer));
    resetTimer(); // Start the timer on mount

    return () => {
      events.forEach(event => window.removeEventListener(event, resetTimer));
      clearTimeout(timerRef.current);
    };
  }, [onTimeout, timeout]);

  // Return null since this is a utility component
  return null;
};

export default IdleTimer;